import { defineStore } from 'pinia';
import { logger } from '../main';
import { Views } from "@/types/ConfigTypes";
export const useNavigationStore = defineStore('navigation', {
    state: () => {
        return {
            path: [],
            currentIndex: 0,
            navigationHeaderTitle: '',
            navigationHeaderText: '',
            views: [],
            loading: true
        };
    },
    getters: {
        getCurrentIndex: (state) => state.currentIndex,
        getCurrentPath: (state) => state.path[state.currentIndex],
        getHistory: (state) => state.path,
        getNavigationHeaderTitle: (state) => state.navigationHeaderTitle,
        getNavigationHeaderText: (state) => state.navigationHeaderText,
        isLoading: (state) => state.loading,
        getViews: (state) => state.views,
    },
    // could also be defined as
    // state: () => ({ count: 0 })
    actions: {
        push(name, params = {}) {
            // remove all path entries
            this.path.length = this.currentIndex + 1;
            const path = { name: name, params: params };
            this.path.push(path);
            this.currentIndex = this.path.length - 1;
            this.setLoadingState(true);
            logger.info('view pushed:', name, params);
        },
        replace(name, params = {}) {
            this.path.splice(this.path.length - 1, 1, {
                name: name,
                params: params
            });
            logger.info('view replaced:', name, params);
        },
        goHome() {
            this.replace(Views.PAGE, { id: 'home' });
        },
        goBack() {
            this.currentIndex -= 1;
            this.setLoadingState(true);
            return this.getCurrentPath;
        },
        setLoadingState(b) {
            this.loading = b;
        },
        setNavHeaderTitle(title) {
            this.navigationHeaderTitle = title;
        },
        setNavHeaderText(text) {
            this.navigationHeaderText = text;
        },
        initViewSelector(views) {
            this.views = views;
        }
    }
});
